// extracted by mini-css-extract-plugin
module.exports = {"policy":"styles_policy__p1DRK","spin":"styles_spin__H2qx4"};